import React from 'react';
import { Box, Grid } from '@mui/material';
import { mockStudents } from '@/data/mockStudents';
import { AttendanceOverview } from './components/AttendanceOverview';
import { GradeBreakdown } from './components/GradeBreakdown';
import { AttendanceTrends } from './components/AttendanceTrends';
import { RecentAbsences } from './components/RecentAbsences';
import { TopPerformers } from './components/TopPerformers';
import { AttentionRequired } from './components/AttentionRequired';

export const AttendanceDashboard: React.FC = () => {
  return (
    <Box sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Grid container spacing={3}>
        {/* Overall Statistics */}
        <Grid item xs={12}>
          <AttendanceOverview students={mockStudents} />
        </Grid>

        {/* Grade Breakdown & Trends */}
        <Grid item xs={12} md={8}>
          <GradeBreakdown students={mockStudents} />
        </Grid>
        <Grid item xs={12} md={4}>
          <AttendanceTrends students={mockStudents} />
        </Grid>

        {/* Recent Absences & Top Performers */}
        <Grid item xs={12} container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box sx={{ height: '100%', display: 'flex' }}>
              <RecentAbsences students={mockStudents} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ height: '100%', display: 'flex' }}>
              <TopPerformers students={mockStudents} />
            </Box>
          </Grid>
        </Grid>

        {/* Students Requiring Attention */}
        <Grid item xs={12}>
          <AttentionRequired students={mockStudents} />
        </Grid>
      </Grid>
    </Box>
  );
};